var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoalignHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(-1524 -283)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1524 283)",
    fill: "#02acf6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "align-horizontal-center",
    transform: "translate(1495 275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M51.429,25.714h-6V22.286H48a1.716,1.716,0,0,0,1.714-1.714V17.143A1.716,1.716,0,0,0,48,15.429H45.429V12H43.714v3.429H41.143a1.716,1.716,0,0,0-1.714,1.714v3.429a1.716,1.716,0,0,0,1.714,1.714h2.571v3.429h-6A1.716,1.716,0,0,0,36,27.429v3.429a1.716,1.716,0,0,0,1.714,1.714h6V36h1.714V32.571h6a1.716,1.716,0,0,0,1.714-1.714V27.429a1.716,1.716,0,0,0-1.714-1.714ZM41.143,17.143H48v3.429H41.143ZM51.429,30.857H37.714V27.429H51.429Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoalignHover);
export default __webpack_public_path__ + "static/media/autoalign-hover.700f404759b922f75d02928012062266.svg";
export { ForwardRef as ReactComponent };